import {
  SET_DB_PLATFORM,
  SET_DB_DB_TYPE,
  SET_DB_OS_TYPE,
  SET_DB_SELECTED_CORE_BUSINESS,
  SET_DB_SELECTED_SOLUTION_AREA,
  GET_DB_CORE_BUSINESS_LIST,
  GET_DB_SOLUTION_AREA,
  SET_DB_SELECTED_SERVICE,
  GET_DB_SERVICES_LIST,
  SET_DB_SELECTED_ENV,
  GET_DB_ENV_LIST,
  GET_DB_SERVERS_LIST,
  GET_DB_SERVERS_LIST_BY_VERSION,
  GET_DB_OVERVIEW_METRICS,
  GET_DB_HIERARCHICAL_DATA,
  GET_DB_TOP20_UNSUPPORTED,
  GET_DB_SERVERS_LIST_BY_ENV,
  GET_DB_PATCH_TIMELINE,
  GET_DB_SWARM_DATA,
  SET_DB_FETCHING_FLAG,
  SET_OS_EOS_DATES_LIST,
  SET_DB_EOS_DATES_LIST,
} from "./types";

const initialState = {
  viewType: "dbvisualization",
  selectedPlatform: 0,
  selectedDbType: "Oracle",
  selectedOsType: "All",
  selectedCoreBusiness: "All",
  selectedSolutionArea: "All",
  selectedEnv: "All",
  selectedService: "All",
  coreBusinessList: [],
  isFetchingCoreBusinessList: false,
  solutionAreaList: [],
  isFetchingSolutionArea: false,
  envList: [],
  isFetchingEnvList: false,
  servicesList: [],
  isFetchingServicesList: false,
  serversList: [],
  isFetchingServersList: false,
  serversListByVersion: [],
  isFetchingServersListByVersion: false,
  overviewMetrics: {},
  isFetchingOverviewMetrics: false,
  hierarchicalData: {},
  isFetchingHierarchicalData: false,
  top20Unsupported: [],
  isFetchingTop20Unsupported: false,
  serversListByEnv: [],
  isFetchingServersListByEnv: false,
  patchTimeline: {},
  isFetchingPatchTimeline: false,
  swarmData: {},
  isFetchingSwarmData: false,
  osEOSDateList: [],
  dbEOSDateList: [],
};

const reducer = (state = initialState, action) => {
  const type = action.type;

  switch (type) {
    case SET_DB_PLATFORM: {
      return {
        ...state,
        selectedPlatform: action.payload,
      };
    }
    case SET_DB_DB_TYPE: {
      return {
        ...state,
        selectedDbType: action.payload,
      };
    }
    case SET_DB_OS_TYPE: {
      return {
        ...state,
        selectedOsType: action.payload,
      };
    }
    case SET_DB_SELECTED_CORE_BUSINESS: {
      return {
        ...state,
        selectedCoreBusiness: action.payload,
      };
    }
    case GET_DB_CORE_BUSINESS_LIST: {
      return {
        ...state,
        coreBusinessList: action.payload,
      };
    }
    case SET_DB_SELECTED_SOLUTION_AREA: {
      return {
        ...state,
        selectedSolutionArea: action.payload,
      };
    }
    case GET_DB_SOLUTION_AREA: {
      return {
        ...state,
        solutionAreaList: action.payload,
      };
    }

    case SET_DB_SELECTED_SERVICE: {
      return {
        ...state,
        selectedService: action.payload,
      };
    }
    case GET_DB_SERVICES_LIST: {
      return {
        ...state,
        servicesList: action.payload,
      };
    }
    case SET_DB_SELECTED_ENV: {
      return {
        ...state,
        selectedEnv: action.payload,
      };
    }
    case GET_DB_ENV_LIST: {
      return {
        ...state,
        envList: action.payload,
      };
    }
    case GET_DB_SERVERS_LIST: {
      return {
        ...state,
        serversList: action.payload,
      };
    }
    case GET_DB_SERVERS_LIST_BY_VERSION: {
      return {
        ...state,
        serversListByVersion: action.payload,
      };
    }
    case GET_DB_OVERVIEW_METRICS: {
      return {
        ...state,
        overviewMetrics: action.payload,
      };
    }
    case GET_DB_HIERARCHICAL_DATA: {
      return {
        ...state,
        hierarchicalData: action.payload,
      };
    }
    case GET_DB_TOP20_UNSUPPORTED: {
      return {
        ...state,
        top20Unsupported: action.payload,
      };
    }
    case GET_DB_SERVERS_LIST_BY_ENV: {
      return {
        ...state,
        serversListByEnv: action.payload,
      };
    }
    case GET_DB_PATCH_TIMELINE: {
      return {
        ...state,
        patchTimeline: action.payload,
      };
    }
    case GET_DB_SWARM_DATA: {
      return {
        ...state,
        swarmData: action.payload,
      };
    }
    case SET_DB_FETCHING_FLAG: {
      let apiType = action.payload.apiType;
      let value = action.payload.value;
      switch (apiType) {
        case "getCoreBusinessList": {
          return {
            ...state,
            isFetchingCoreBusinessList: value,
          };
        }
        case "getSolutionAreaList": {
          return {
            ...state,
            isFetchingSolutionArea: value,
          };
        }
        case "getServicesList": {
          return {
            ...state,
            isFetchingServicesList: value,
          };
        }
        case "getEnvList": {
          return {
            ...state,
            isFetchingEnvList: value,
          };
        }
        case "getServersList": {
          return {
            ...state,
            isFetchingServersList: value,
          };
        }
        case "getServersListByVersion": {
          return {
            ...state,
            isFetchingServersListByVersion: value,
          };
        }
        case "getOverviewMetrics": {
          return {
            ...state,
            isFetchingOverviewMetrics: value,
          };
        }
        case "getHierarchicalData": {
          return {
            ...state,
            isFetchingHierarchicalData: value,
          };
        }
        case "getTop20Unsupported": {
          return {
            ...state,
            isFetchingTop20Unsupported: value,
          };
        }
        case "getServersListByEnv": {
          return {
            ...state,
            isFetchingServersListByEnv: value,
          };
        }
        case "getPatchTimeline": {
          return {
            ...state,
            isFetchingPatchTimeline: value,
          };
        }
        case "getSwarmData": {
          return {
            ...state,
            isFetchingSwarmData: value,
          };
        }
        default:
          return { ...state };
      }
    }
    case SET_OS_EOS_DATES_LIST: {
      return {
        ...state,
        osEOSDateList: action.payload,
      };
    }
    case SET_DB_EOS_DATES_LIST: {
      return {
        ...state,
        dbEOSDateList: action.payload,
      };
    }

    default:
      return { ...state };
  }
};

export default reducer;
